import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Logout from "../../common/Logout";
import CustomSliderV2 from "../../common/CustomSliderV2";
import CustomModalWrapper from "../../common/CustomModalV2/wrapper";

import SlideWelcomePage from "./components/SlideWelcomePage";
import SlidePersonalInfo from "./components/SlidePersonalInfo";
import PersonalInfoPostMessage from "./components/PersonalInfoPostMessage";
import SlideSelectDays from "./components/SlideSelectDays";
import SlideSelectMinutesPerWeek from "./components/SlideSelectMinutesPerWeek";
import SlideSelectConsistency from "./components/SlideSelectConsistency";
import SlideSelectWorkoutLength from "./components/SlideSelectWorkoutLength";
import SlidePreGoal from "./components/SlidePreGoal";
import SlideSelectGoals from "./components/SlideSelectGoals";
import SlidePreProgram from "./components/SlidePreProgram";
import SlideSelectProgram from "./components/SlideSelectProgram";
import SlideLoader from "./components/SlideLoader";
import SlideSignup from "./components/SlideSignup";
import SlidePayment from "./components/SlidePayment";
import SlideWorkoutPlan from "./components/SlideWorkoutPlan";
import ProgressIndicator from "./components/ProgressIndicator";

import { GetSurveyGoals, LinkScheduleToUser, LoadAccountDetails } from "../../redux/v2/user/actions";
import { GetPrograms } from "../../redux/v2/program/actions";

import useWorkoutPlan from "../../hooks/useWorkoutPlan";
import { checkIfUsingMobileApp } from "../../utils/userResource";
import { socket, socketS2, callSocket } from "../../utils/socket";
import { delay } from "../../utils";

import "./style.css";


function OnboardingV2(props) {
    const { page } = useParams();
    const navigate = useNavigate();

    const platform = new URLSearchParams(window.location.search).get("platform");
    const sessionID = new URLSearchParams(window.location.search).get("session_id");
    if ((platform != null && platform != "null")) {
        localStorage.setItem("indi-platform", platform);
    }
    if ((sessionID != null && sessionID != "null")) {
        localStorage.setItem("indi-native-session", sessionID);
    }
    const lsSessionID = localStorage.getItem("indi-native-session");

    const isUsingMobileApp = checkIfUsingMobileApp();
    const sliderRef = useRef(null);
    const [slide, setSlide] = useState(page ? parseInt(page) : 0);
    const [showIndicator, setShowIndicator] = useState(true);
    const [scheduleID, setScheduleID] = useState(null);
    const [userID, setUserID] = useState(null);
    const [userSessionID, setUserSessionID] = useState(null);
    const [wpProgress, setWPProgress] = useState({ progress: 0, message: "Working on it" });
    const [authProviderCredential, setAuthProviderCredential] = useState(null);
    const [preRegistrationDetails, setPreRegistrationDetails] = useState({
        personalInfo: {
            firstName: "",
            lastName: "",
            dob: "",
            gender: "",
        },
        daysToWorkout: [],
        minutesPerWeek: "",
        consistency: "",
        preferedWorkoutLength: "",
        goals: [],
        programs: [],
    });
    const { surveyGoals, account } = props?.User;
    const { programs } = props?.Program;
    const { workoutPlan } = useWorkoutPlan({ account, programs });

    const wpIDTemp = localStorage.getItem("wp-id-temp");

    const ListenOnboardingNativeResponse = () => {
        socket.removeAllListeners(`app-onboarding-response-${lsSessionID}`);
        socket.on(`app-onboarding-response-${lsSessionID}`, (data) => {

            if (data.data.type == "apple-auth-credential") {
                setAuthProviderCredential(data?.data?.data);
            } else if (data.data.type == "google-auth-credential") {
                setAuthProviderCredential(data?.data?.data);
            }
        });
    };

    const moveNext = (e, pSlide = null) => {
        let s = pSlide || (slide + 1);
        sliderRef?.current?.slickGoTo(s);
        setSlide(ps => ps = s);
    }

    const moveBack = (e, pSlide = null) => {
        let s = pSlide || (slide - 1);
        sliderRef?.current?.slickGoTo(s);
        setSlide(ps => ps = s);
    }

    const backLogin = () => {
        if (isUsingMobileApp) {
            callSocket(`interact-onboarding`, { type: "back-login", sessionID: lsSessionID });
        } else {
            navigate("/login");
        }
    }

    const ListenWPProgress = (id) => {
        socketS2.removeAllListeners(`update-workout-plan-generate-progress-${id}`);
        socketS2.on(`update-workout-plan-generate-progress-${id}`, (data) => {
            setWPProgress(data?.data);
        });
    };

    useEffect(() => {
        props.GetSurveyGoals();
        props.GetPrograms();

        ListenOnboardingNativeResponse();

        const tempSessionID = new Date().getTime();
        setUserSessionID(tempSessionID);
        ListenWPProgress(tempSessionID);
    }, []);

    useEffect(() => {
        // const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : "http://localhost:3000/");
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : process.env.REACT_APP_APP_URL_DEV);
        window?.history?.pushState({}, "", `${link}user-onboarding/${slide}`);
    }, [slide]);

    useEffect(() => {
        const cb = async () => {
            if ((scheduleID || wpIDTemp) && userID) {
                await props.LinkScheduleToUser(scheduleID || wpIDTemp, userID);
                await props.LoadAccountDetails();
                delay(() => {
                    moveNext({}, slide + 1);
                }, 1000)
            }
        }

        cb();
    }, [scheduleID, userID, wpIDTemp]);

    const hideConsistency = preRegistrationDetails?.minutesPerWeek == "0 Mins";
    let hidden = 0;
    if (hideConsistency) hidden++;

    return (
        <div id="user-onboarding">
            <Logout showLogo showLogout={false} backAction={slide < (12 - hidden) ? () => {
                if (slide == 0) {
                    backLogin();
                } else {
                    moveBack();
                }
            } : null} />
            <CustomSliderV2
                id="uo-custom-slider"
                sliderRef={sliderRef}
                swipe={false}
                draggable={false}
                afterChange={(current) => {
                    setSlide(current);
                }}
                initialSlide={parseInt(page)}
            // page={8}

            >
                <SlideWelcomePage preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} backLogin={backLogin} />
                <SlidePersonalInfo preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <PersonalInfoPostMessage preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectDays preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectMinutesPerWeek preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                {!hideConsistency && <SlideSelectConsistency preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />}
                <SlideSelectWorkoutLength preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlidePreGoal preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectGoals preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} surveyGoals={surveyGoals} />
                <SlidePreProgram preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectProgram displayType={2} preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} setShowIndicator={setShowIndicator} setScheduleID={setScheduleID} userSessionID={userSessionID} />
                <SlideSignup preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} moveBack={moveBack} slide={slide} sessionID={lsSessionID} authProviderCredential={authProviderCredential} setUserID={setUserID} />
                <SlideLoader preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} showProgress={true} wpProgress={wpProgress} isPageActive={slide == (12 - hidden)} />
                <SlideWorkoutPlan workoutPlan={workoutPlan} moveNext={() => {
                    if (isUsingMobileApp) {
                        callSocket(`interact-onboarding`, { type: "set-token", sessionID: lsSessionID, token: localStorage.getItem("temp-access-token") });
                    } else {
                        moveNext();
                    }
                }
                } />
                <SlidePayment preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
            </CustomSliderV2>

            <CustomModalWrapper />

            {/* {showIndicator && <ProgressIndicator length={14} currentBar={slide} />} */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetSurveyGoals,
    LinkScheduleToUser,
    LoadAccountDetails,
    GetPrograms,
})(OnboardingV2);
